// import { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { getCurrentUser } from "../../services/authService";
// import axios from "axios";

// export default function Sidebar() {
//   const [selected, setSelected] = useState(null);
//   const [toast, setToast] = useState(null);
//   const [pwdLoading, setPwdLoading] = useState(false);
//   const [stats, setStats] = useState({ total: 0, matched: 0, shortlisted: 0, viewed: 0 });
//   const [shortlisted, setShortlisted] = useState([]);
//   const [showPasswordModal, setShowPasswordModal] = useState(false);
//   const [passwordForm, setPasswordForm] = useState({
//     currentPassword: "",
//     newPassword: "",
//     confirmPassword: "", 
//   });

//   const navigate = useNavigate();

//   const [user] = useState(() => {
//     const stored = localStorage.getItem("user");
//     return stored ? JSON.parse(stored) : null;
//   });

//   const displayName = user?.username || user?.name || "User";
//   const displayEmail = user?.email || "";
//   const memberSince = user?.createdAt
//     ? new Date(user.createdAt).toLocaleDateString("en-IN", {
//         month: "short",
//         year: "numeric",
//       })
//     : "Member";

//   // ── Helpers ──────────────────────────────────────────────────────────────
//   const showToast = useCallback((msg, type = "success") => {
//     setToast({ msg, type });
//     setTimeout(() => setToast(null), 3000);
//   }, []);

//   const authHeaders = () => ({
//     headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//   });

//   const initials = (name) =>
//     name
//       ? name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2)
//       : "?";

//   // ── Data fetching ─────────────────────────────────────────────────────────
//   const fetchUsers = useCallback(async () => {
//     try {
//       const res = await getCurrentUser();
//       const data = Array.isArray(res?.data) ? res.data : [res?.data || res];
//       setSelected(data.length > 0 ? data[0] : null);
//       setStats({
//         total: data.length || 0,
//         matched: Math.floor(data.length * 0.6) || 0,
//         shortlisted: Math.floor(data.length * 0.2) || 0,
//         viewed: data.length || 0,
//       });
//     } catch {
//       showToast("Failed to load profiles", "error");
//     }
//   }, [showToast]);

//   useEffect(() => {
//     fetchUsers();
//   }, [fetchUsers]);


//   // ── Handlers ──────────────────────────────────────────────────────────────
//   const handlePasswordChange = (e) =>
//     setPasswordForm({ ...passwordForm, [e.target.name]: e.target.value });

//   const toggleShortlist = (id) => {
//     if (!id) return;
//     setShortlisted((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
//     );
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     navigate("/");
//   };
// const matches = () => {
//     navigate("/matches");
//   };
  
//   const handlePasswordSubmit = async () => {
//     const { currentPassword, newPassword, confirmPassword } = passwordForm;
//     if (!currentPassword || !newPassword || !confirmPassword)
//       return showToast("All fields are required", "error");
//     if (newPassword.length < 6)
//       return showToast("New password must be at least 6 characters", "error");
//     if (newPassword !== confirmPassword)
//       return showToast("Passwords do not match", "error");

//     setPwdLoading(true);
//     try {
//       await axios.post(
//         "http://localhost:5000/api/auth/change-password",
//         { currentPassword, newPassword },
//         authHeaders()
//       );
//       showToast("Password changed successfully!");
//       setShowPasswordModal(false);
//       setPasswordForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
//     } catch (err) {
//       showToast(err.response?.data?.message || "Error changing password", "error");
//     }
//     setPwdLoading(false);
//   };

//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <>
//       {/* Toast Notification */}
//       {toast && (
//         <div className={`toast toast-${toast.type}`}>
//           {toast.msg}
//         </div>
//       )}

//       {/* Sidebar */}
//       <aside className="sidebar">
//         <div className="sidebar-header">
//           <div className="brand">
//             <span className="brand-logo"></span>
//             <div>
//               <div className="brand-name">
//                 Niran<em> Matrimony</em>
//               </div>
//               <div className="brand-tagline">Finding Your Perfect Match</div>
//             </div>
//           </div>
//         </div>
                
//         <div className="logged-user">
//           <div className="logged-avatar">{initials(displayName)}</div>
//           <div className="logged-info">
//             <div className="logged-name">{displayName}</div>
//             <div className="logged-email">{displayEmail}</div>
//             <div className="logged-badge">✓ Verified Account</div>
//           </div>
//           <button className="logout-btn" onClick={handleLogout} title="Logout">
//             <svg
//               width="16"
//               height="16"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
//               <polyline points="16 17 21 12 16 7" />
//               <line x1="21" y1="12" x2="9" y2="12" />
//             </svg>
//           </button>
//         </div>

//         <div className="sidebar-meta">
//           <div className="as-item">
//             <span className="as-icon"></span>
//             <div>
//               <div className="as-label">Member Since</div>
//               <div className="as-value">{memberSince}</div>
//             </div>
//           </div>
//         </div>

//         {/* Stats (optional display)
//         <div className="sidebar-stats">
//           <div className="stat-item">
//             <span className="stat-value">{stats.total}</span>
//             <span className="stat-label">Total</span>
//           </div>
//           <div className="stat-item">
//             <span className="stat-value">{stats.matched}</span>
//             <span className="stat-label">Matched</span>
//           </div>
//           <div className="stat-item">
//             <span className="stat-value">{stats.shortlisted}</span>
//             <span className="stat-label">Shortlisted</span>
//           </div>
//         </div> */}

//         <button
//           className="change-pass-btn"
//           onClick={() => setShowPasswordModal(true)}
//         >
//           Change Password
//         </button>

//         <button
//           className={`btn-shortlist ${
//             shortlisted.includes(selected?._id) ? "active" : ""
//           }`}
//           onClick={() => toggleShortlist(selected?._id)}
//           disabled={!selected?._id}
//         >
//           {shortlisted.includes(selected?._id) ? "✓ Shortlisted" : "Shortlist"}
//         </button>
//           <button
//                   className="change-pass-btn"
//                   onClick={matches}>
//                   Matches
//           </button>
//         {/* Uncomment to enable subscription button */}
//         {/* <button className="change-pass-btn1" onClick={() => navigate("/subscription")}>
//           Subscription
//         </button> */}
//       </aside>

//       {/* Password Modal */}
//       {showPasswordModal && (
//         <div
//           className="overlay"
//           onClick={(e) =>
//             e.target === e.currentTarget && setShowPasswordModal(false)
//           }
//         >
//           <div className="modal">
//             <div className="modal-header">
//               <div className="modal-title">Change Password</div>
//               <button
//                 className="close-btn"
//                 onClick={() => setShowPasswordModal(false)}
//               >
//                 ✕
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="form-group">
//                 <label>Current Password</label>
//                 <input
//                   type="password"
//                   name="currentPassword"
//                   value={passwordForm.currentPassword}
//                   onChange={handlePasswordChange}
//                   placeholder="Enter current password"
//                 />
//               </div>
//               <br />
//               <div className="form-group">
//                 <label>New Password</label>
//                 <input
//                   type="password"
//                   name="newPassword"
//                   value={passwordForm.newPassword}
//                   onChange={handlePasswordChange}
//                   placeholder="Min. 6 characters"
//                 />
//               </div>
//               <br />
//               <div className="form-group">
//                 <label>Confirm New Password</label>
//                 <input
//                   type="password"
//                   name="confirmPassword"
//                   value={passwordForm.confirmPassword}
//                   onChange={handlePasswordChange}
//                   placeholder="Re-enter new password"
//                 />
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 className="btn-cancel"
//                 onClick={() => setShowPasswordModal(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="btn-save"
//                 onClick={handlePasswordSubmit}
//                 disabled={pwdLoading}
//               >
//                 {pwdLoading ? "Updating..." : "Update Password"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../../services/authService";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { logout, updateUserPassword } from "../../redux/authSlice";
import userAvatar from "../../img/user-avatar.png";  
import { Link } from "react-router-dom";
import "../../pages/Dashboard.css"; 

function Avatar({ profileId, color, name, profileIcon, photos }) {
  const imageUrl = photos?.url
  ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${photos.url}`
  : userAvatar || "/default-avatar.png";
  const initials = name?.split(" ")
    .map((n) => n[0])
    .join("");
  return (
    <div className="avatar" style={{ background: color }}>
      <Link to={`/profile/${profileId}`} >
      <img 
        src={imageUrl}  
        alt="profile" 
        className="avatar-img" 
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = userAvatar;
        }}
      />
      </Link>
    </div>
  );
}


export default function Sidebar({ profileImage, profileDetails }) {
  const [profile, setProfile] = useState(null);
  const [selected, setSelected] = useState(null);
  const [toast, setToast] = useState(null);
  const [pwdLoading, setPwdLoading] = useState(false);
  const [stats, setStats] = useState({ total: 0, matched: 0, shortlisted: 0, viewed: 0 });
  const [shortlisted, setShortlisted] = useState([]);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [userType, setUserType] = useState("");
   const { recommendedMatches } = useSelector((state) => state.profile);
  const [recommendedProfiles, setRecommendedProfiles] = useState([]);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "", 
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
    const userFromStore = useSelector((state) => state.auth.user);
    const userFromLoginResponse = useSelector((state) => state.auth.loginResponse);
  useEffect(() => {
    if (userFromStore?.profile) {
      setProfile(userFromStore.profile);
    }
  }, [userFromStore]);

useEffect(() => {
  try {
    const stored = localStorage.getItem("user");

    if (!stored || stored === "undefined") {
      console.log("useEffect: null");
      return;
    }

    const userFromStorage = JSON.parse(stored);

    console.log("useEffect:", userFromStorage);

    if (userFromStorage) {
      setUserType(userFromStorage);
    }
  } catch (err) {
    console.error("Invalid JSON in localStorage:", err);
  }
}, []);

 const [user] = useState(() => {
  try {
    const stored = localStorage.getItem("user");

    if (!stored || stored === "undefined") {
      return null;
    }

    return JSON.parse(stored);
  } catch (err) {
    console.error("Invalid JSON:", err);
    return null;
  }
});


useEffect(() => {
  if(recommendedMatches?.matches) {
    console.log('Recommended Matches:', recommendedMatches);
    let recommendedProfiles = [];
    let data =recommendedMatches.matches;
    data?.slice(0,4).forEach(match => {
     const profileURL = match.photos.find(photo => photo.isPrimary);
     console.log('Profile URL:', profileURL);
     
     recommendedProfiles.push({
        _id: match._id,
        name: match?.fullName ?? match.firstName + " " + match.lastName,
        age: match.age,
        location: match.location,
        photos: profileURL ?? userAvatar,
        matchPercent: match.matchPercent
      })
    });
    setRecommendedProfiles(recommendedProfiles);
  }
}, [recommendedMatches]);


  const displayName = user?.username || user?.name || "User";
  const displayEmail = user?.email || "";
  const memberSince = user?.createdAt
    ? new Date(user.createdAt).toLocaleDateString("en-IN", {
        month: "short",
        year: "numeric",
      })
    : "Member";

  // ── Helpers ─────────────────────────────────────────
  const showToast = useCallback((msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  }, []);

  const authHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });

  const initials = (name) =>
    name
      ? name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2)
      : "?";

  // ── Fetch User ──────────────────────────────────────
  const fetchUsers = useCallback(async () => {
    try {
      const res = await getCurrentUser();
      const data = Array.isArray(res?.data) ? res.data : [res?.data || res];
      setSelected(data.length > 0 ? data[0] : null);
      setStats({
        total: data.length || 0,
        matched: Math.floor(data.length * 0.6) || 0,
        shortlisted: Math.floor(data.length * 0.2) || 0,
        viewed: data.length || 0,
      });
    } catch {
      showToast("Failed to load profiles", "error");
    }
  }, [showToast]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  // ── Handlers ────────────────────────────────────────
  const handlePasswordChange = (e) =>
    setPasswordForm({ ...passwordForm, [e.target.name]: e.target.value });

  const toggleShortlist = (id) => {
    if (!id) return;
    setShortlisted((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    dispatch(logout());
    navigate("/login");
  };

  const matches = () => {
    navigate("/matches");
  };

  const handlePasswordSubmit = async () => {
  const { currentPassword, newPassword, confirmPassword } = passwordForm;
  if (!currentPassword || !newPassword || !confirmPassword)
    return showToast("All fields are required", "error");
  if (newPassword.length < 6)
    return showToast("New password must be at least 6 characters", "error");
  if (newPassword !== confirmPassword)
    return showToast("Passwords do not match", "error");
  if (currentPassword === newPassword || currentPassword === confirmPassword)
    return showToast(
      "Current password, new password should not be same. Please enter a new password",
      "error"
    );

  setPwdLoading(true);
  try {
    await dispatch(updateUserPassword({ currentPassword, newPassword })).unwrap();
    showToast("Password changed successfully!");
    setShowPasswordModal(false);
    setPasswordForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
  } catch (err) {
    showToast(err?.message || "Error changing password", "error");
  } finally {
    setPwdLoading(false);
  }
};
  // ── UI ──────────────────────────────────────────────
  return (
    <>
      {/* Toast */}
      {toast && (
        <div className={`toast toast-${toast.type}`}>
          {toast.msg}
        </div>
      )}

      <aside className="sidebar">
        {/* Header */}
        <div className="sidebar-header">
          <div className="brand">
            <span className="brand-logo"></span>
            <div>
              <div className="brand-name">
                Niran<em> Matrimony</em>
              </div>
              <div className="brand-tagline">Finding Your Perfect Match</div>
            </div>
          </div>
        </div>

        {/* User */}
        <div className="logged-user">
  <div className="logged-avatar">
    {profileImage ? (
      <img
        src={`${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileImage}`}
        alt="profile"
        className="avatar-img"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = userAvatar;
        }}
      />
    ) : (
       <div className="logged-avatar-inner"> 
      <Avatar
        profileId={profile?._id}
        color={profile?.color}
        name={profile?.name}
        profileIcon={profile?.profileIcon}
        photos={profile?.photos}
      />
    </div>
    )}
  </div>
  <div className="logged-info">
    <div className="logged-name">{profile?.userId?.userName || displayName}</div>
    <div className="logged-email">{displayEmail}</div>
    <div className="logged-badge">✓ Verified Account</div>
  </div>
  <button className="logout-btn" onClick={handleLogout}>
    Logout
  </button>
</div>

        {/* Member Since */}
        <div className="sidebar-meta">
          <div className="as-item">
            <div>
              <div className="as-label">Member Since</div>
              <div className="as-value">{memberSince}</div>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <button
          className="change-pass-btn"
          onClick={() => setShowPasswordModal(true)}
        >
          Change Password
        </button>

        {/* <button
          className={`btn-shortlist ${
            shortlisted.includes(selected?._id) ? "active" : ""
          }`}
          onClick={() => toggleShortlist(selected?._id)}
          disabled={!selected?._id}
        >
          {shortlisted.includes(selected?._id) ? "✓ Shortlisted" : "Shortlist"}
        </button> */}

        <button className="change-pass-btn" onClick={matches}>
          Matches
        </button>
          {userType?.role === "admin" && (
            <>
              <button className="change-pass-btn" onClick={() => navigate("/create-profile")}>
                Profiles
              </button>
              <button className="change-pass-btn" onClick={() => navigate("/create-story")}>
                Create Story
              </button>
              <button className="change-pass-btn" onClick={() => navigate("/payment-users")}>
                Payment Users
              </button>
            </>
          )}
      </aside>
          <br/>
      {/* Password Modal */}
      {showPasswordModal && (
        <div
          className="overlay"
          onClick={(e) =>
            e.target === e.currentTarget && setShowPasswordModal(false)
          }
        >
          <div className="modal">
            <div className="modal-password-header">
              <div className="modal-title">Change Password</div>
              <button onClick={() => setShowPasswordModal(false)} className="modal-close-btn">✕</button>
            </div>

            <div className="modal-password-inputs">
              <input
                type="password"
                name="currentPassword"
                placeholder="Current Password"
                value={passwordForm.currentPassword}
                onChange={handlePasswordChange}
              />
              <input
                type="password"
                name="newPassword"
                placeholder="New Password"
                value={passwordForm.newPassword}
                onChange={handlePasswordChange}
              />
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={passwordForm.confirmPassword}
                onChange={handlePasswordChange}
              />
            </div>

            <div className="modal-password-footer">
              <button onClick={() => setShowPasswordModal(false)}>Cancel</button>
              <button onClick={handlePasswordSubmit} disabled={pwdLoading}>
                {pwdLoading ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}